export const overviewReducer = (state, action) => {
  switch (action.type) {
    case "UPDATE_OBJECTS":
      return {
        objects: action.objects,
        notifications: state.notifications,
        devices: state.devices,

        prevObjects: state.objects,
        prevNotifications: state.notifications,
        prevDevices: state.devices,
      };
    case "UPDATE_NOTIFICATION":
      return {
        objects: state.objects,
        notifications: action.notifications,
        devices: state.devices,

        prevObjects: state.objects,
        prevNotifications: state.notifications,
        prevDevices: state.devices,
      };
    case "UPDATE_DEVICES":
      return {
        objects: state.objects,
        notifications: state.notifications,
        devices: action.devices,

        prevObjects: state.objects,
        prevNotifications: state.notifications,
        prevDevices: state.devices,
      };
    default:
      return state;
  }
};
